module.exports = __webpack_public_path__ + "img/ring_r_skip_0_0@2x.19800a1c.png";